import cx from "classnames";
import { type HTMLAttributes, type PropsWithChildren, forwardRef } from "react";

import styles from "./stack.module.scss";

type StackProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  gap?: "sm" | "md" | "lg" | "xl" | "2xl";
};

// React 19 will deprecate forwardRef: https://react.dev/reference/react/forwardRef
export const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ children, gap = "xl", className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cx(styles.stack, className, {
          [styles.gapSm]: gap === "sm",
          [styles.gapMd]: gap === "md",
          [styles.gapLg]: gap === "lg",
          [styles.gapXl]: gap === "xl",
          [styles.gap2Xl]: gap === "2xl",
        })}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = "Stack";
